// alpha of the main noise
let noiseAlpha = 0.15;

// name of the effect in the post processing stack
let effectName = 'noise';

// adds the effect to the post processing stack
function addNoiseToStack(postProcessingStack) {
    postProcessingStack.addEffect(effectName, noiseVert, noiseFrag);
}

// updates the effect (should be called before the post processing stack is applied)
function updateNoise(p5, postProcessingStack) {
    postProcessingStack.setUniforms(effectName, {'u_time': p5.millis() / 1000, 'u_alpha': noiseAlpha});
}

let noiseVert = `
attribute vec4 aPosition;

varying vec2 v_uv;

void main() {
    // calculate uvs
    v_uv = aPosition.xy;
    v_uv.y *= -1.0;
    v_uv.x = v_uv.x * 0.5 + 0.5;
    v_uv.y = v_uv.y * 0.5 + 0.5;

    // set position
    gl_Position = aPosition;
}
`;

let noiseFrag = `
precision highp float;

uniform sampler2D u_mainTex;
uniform float u_alpha;
uniform float u_time;

// uv coordinates
varying vec2 v_uv;

float random(vec2 pos) {
    return fract(sin(dot(pos.xy,vec2(12.9898,78.233)))*43758.5453123);
}

void main() {
    float rand = random(v_uv+mod(u_time, 10.0));
    vec4 noise = vec4(rand, rand, rand, u_alpha);
    vec4 baseCol = texture2D(u_mainTex, v_uv);
    gl_FragColor = noise.a*noise + (1.0-noise.a)*baseCol;
}
`;

module.exports = {
    updateNoise,
    addNoiseToStack
}
